// ### Function accepts number or string and returns string with thousands " " separator

export const formatPrice = (x: string | number) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
};
